import Typography from '@mui/material/Typography'
import styled from '@mui/material/styles/styled'

export const HelperText = styled(Typography, {
  name: 'HelperText',
  slot: 'Root',
  skipSx: true,
})(
  ({ theme }) => `
  color: ${theme.palette.text.secondary};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
  font-family: Source Sans Pro, sans-serif;
  font-weight: 400;
`,
)
